
<title>Shell Box | Beneficios, Descuentos y Promociones</title>
<meta name="description" content="Canjeá tus millas a puntos Shell Box y obtené beneficios y descuentos. Registrate y comenzá a ganar cargando combustibles y comprando en nuestras tiendas.">
<link rel="canonical" href="https://shellbox.shell.com.ar">
<meta name="keywords" content="shell box, shell puntos, puntos shell, shell box descuentos, shell descuentos, shell box promociones, descuentos shell">

<div class="main-container">
<app-popup 
  *ngIf="showFirstPopup"
  [id]="isMobile ? 'popUpDashboardMobile' : 'popUpDashboard'"
  [imageUrl]="'../../../assets/pop-up/popUpMarketShellHotSole.png'"
  [redirectUrl]="'https://marketshell.shell.com.ar/?utm_medium=popup&utm_source=web&utm_campaign=on_hotsale_2025&utm_content=home'">
</app-popup>
<app-popup 
  *ngIf="!showFirstPopup"
  [id]="isMobile ? 'popUpDashboardMobile' : 'popUpDashboard'"
  [imageUrl]="'../../../assets/pop-up/popUpMarketShell.png'"
  [redirectUrl]="'https://marketshell.shell.com.ar/?utm_medium=Popup&utm_source=Web_Shellbox&utm_campaign=MarketShell_Mercado_Pago'">
</app-popup>
  <div class="section is-hero">
    <swiper #swiperHero [config]="sliders.length > 1 ? configHeader : {}" *ngIf="sliders.length > 1 && !isMobile" class="swiper-home">
      <ng-template swiperSlide *ngFor="let item of bannerListDesktop; let i = index">
        <ng-container *ngIf="item.videoLink && item.videoLink !== 'null'; else desktopImage">
          <div class="bg-video">
            <iframe
              [src]="transformVideoLink(item.videoLink) | safeUrl"
              frameborder="0"
              allow="autoplay; encrypted-media"
              sandbox="allow-scripts allow-same-origin"
              loading="lazy"
              alt="video promo"
              class="iframe">
            </iframe>
          </div>
        </ng-container>
        <ng-template #desktopImage>
          <img [src]="item.imgUrl" class="swiper-img" alt="promos">
        </ng-template>
      </ng-template>
    
      <ng-template swiperSlide *ngFor="let item of sliders">
        <ng-container *ngIf="item.videoLink && item.videoLink !== 'null'; else checkVideoDesktop">
          <div class="bg-video">
            <iframe
              [src]="transformVideoLink(item.videoLink) | safeUrl"
              frameborder="0"
              allow="autoplay; encrypted-media"
              sandbox="allow-scripts allow-same-origin"
              loading="lazy"
              alt="video promo"
              class="iframe">
            </iframe>
          </div>          
        </ng-container>
        <ng-template #checkVideoDesktop>
          <ng-container *ngIf="item.videoDesktop && item.videoDesktop !== 'null'; else sliderContent">
            <ng-container *ngIf="isGif(item.videoDesktop); else videoTagDesktop">
              <img [src]="item.videoDesktop" class="gif-option" alt="slider gif">
            </ng-container>
            <ng-template #videoTagDesktop>
              <video autoplay loop #videoDesktop [src]="item.videoDesktop" class="video-option"></video>
            </ng-template>
          </ng-container>
        </ng-template>
        <ng-template #sliderContent>
          <app-slider [item]="item" [isHome]="true"></app-slider>
        </ng-template>
      </ng-template>
    </swiper>   
    <swiper #swiperHero [config]="sliders.length === 1 ? config : {}" *ngIf="sliders.length === 1 && !isMobile" class="swiper-home">
      <ng-template swiperSlide *ngFor="let item of sliders">
        <ng-container *ngIf="item.videoLink && item.videoLink !== 'null'; else checkSingleVideoDesktop">
          <div class="bg-video">
            <iframe
              [src]="transformVideoLink(item.videoLink) | safeUrl"
              frameborder="0"
              allow="autoplay; encrypted-media"
              sandbox="allow-scripts allow-same-origin"
              loading="lazy"
              alt="video promo"
              class="iframe">
            </iframe>
          </div>
        </ng-container>
        <ng-template #checkSingleVideoDesktop>
          <ng-container *ngIf="item.videoDesktop && item.videoDesktop !== 'null'; else singleSliderContent">
            <ng-container *ngIf="isGif(item.videoDesktop); else videoTagDesktopSingle">
              <img [src]="item.videoDesktop" class="gif-option" alt="slider gif">
            </ng-container>
            <ng-template #videoTagDesktopSingle>
              <video autoplay loop #videoDesktop [src]="item.videoDesktop" class="video-option"></video>
            </ng-template>
          </ng-container>
        </ng-template>
        <ng-template #singleSliderContent>
          <app-slider [item]="item" [isHome]="true"></app-slider>
        </ng-template>
      </ng-template>
    </swiper>

    <swiper #swiperHeroMobile [config]="sliders.length > 1 ? configHeaderMobile : {}" *ngIf="sliders.length > 1 && isMobile" class="swiper-home">
      <ng-template swiperSlide *ngFor="let item of bannerListMobile; let i = index">
        <ng-container *ngIf="item.videoLink && item.videoLink !== 'null'; else mobileImage">
          <div class="bg-video">
            <iframe
              [src]="transformVideoLink(item.videoLink) | safeUrl"
              frameborder="0"
              allow="autoplay; encrypted-media"
              sandbox="allow-scripts allow-same-origin"
              loading="lazy"
              alt="video promo"
              class="iframe">
            </iframe>
          </div>
        </ng-container>
        <ng-template #mobileImage>
          <img [src]="item.imgUrlMobile" class="swiper-img" alt="promos">
        </ng-template>
      </ng-template>
      <ng-template swiperSlide *ngFor="let item of sliders">
        <ng-container *ngIf="item.videoLink && item.videoLink !== 'null'; else checkVideoMobile">
          <div class="bg-video">
            <iframe
              [src]="transformVideoLink(item.videoLink) | safeUrl"
              frameborder="0"
              allow="autoplay; encrypted-media"
              sandbox="allow-scripts allow-same-origin"
              loading="lazy"
              alt="video promo"
              class="iframe">
            </iframe>
          </div>
        </ng-container>      
        <ng-template #checkVideoMobile>
          <ng-container *ngIf="item.videoMobile && item.videoMobile !== 'null'; else mobileSliderContent">
            <ng-container *ngIf="isGif(item.videoMobile); else videoTagMobile">
              <img [src]="item.videoMobile" class="gif-option" alt="slider gif">
            </ng-container>
            <ng-template #videoTagMobile>
              <video autoplay loop #videoMobile [src]="item.videoMobile" class="video-option"></video>
            </ng-template>
          </ng-container>
        </ng-template>
        <ng-template #mobileSliderContent>
          <app-slider [item]="item" [isHome]="true"></app-slider>
        </ng-template>
      </ng-template>
    </swiper>
    <swiper #swiperHeroMobile [config]="sliders.length === 1 ? config : {}" *ngIf="sliders.length === 1 && isMobile" class="swiper-home">
      <ng-template swiperSlide *ngFor="let item of sliders">
        <ng-container *ngIf="item.videoLink && item.videoLink !== 'null'; else checkSingleVideoMobile">
          <div class="bg-video">
            <iframe
              [src]="transformVideoLink(item.videoLink) | safeUrl"
              frameborder="0"
              allow="autoplay; encrypted-media"
              sandbox="allow-scripts allow-same-origin"
              loading="lazy"
              alt="video promo"
              class="iframe">
            </iframe>
          </div>
        </ng-container>
        <ng-template #checkSingleVideoMobile>
          <ng-container *ngIf="item.videoMobile && item.videoMobile !== 'null'; else singleMobileSliderContent">
            <ng-container *ngIf="isGif(item.videoMobile); else videoTagSingleMobile">
              <img [src]="item.videoMobile" class="gif-option" alt="slider gif">
            </ng-container>
            <ng-template #videoTagSingleMobile>
              <video autoplay loop #videoMobile [src]="item.videoMobile" class="video-option"></video>
            </ng-template>
          </ng-container>
        </ng-template>
        
        <ng-template #singleMobileSliderContent>
          <app-slider [item]="item" [isHome]="true"></app-slider>
        </ng-template>
      </ng-template>
    </swiper>
    
    <div class="btn-container" *ngIf="sliders.length > 1">
      <div (click)="isMobile ? slidePrevMobile() : slidePrev()" class="swiper-button-prev"></div>
      <div (click)="isMobile ? slideNextMobile() : slideNext()" class="swiper-button-next"></div>
    </div>    
  </div>

  <div class="option-container" *ngIf="!isMobile">
    <div class="option-detail" *ngFor="let option of options">
      <div class="option-convesor">
        <img [src]="option.imageSrc" alt="{{ option.title }}">
        <div class="option-title">
          <div class="option-description">
            <h3>{{ option.title }}</h3>
            <p>{{ option.description }}</p>
          </div>
          <div class="know-more">
            <a [href]="option.link">Conocé más</a>
            <img src="../../../assets/icon/icon-know-more.svg" alt="Conocé más">
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="option-container" *ngIf="isMobile">
    <swiper [config]="optionsRedirect">
      <ng-container *ngFor="let option of options">
        <ng-template swiperSlide>
          <div class="option-detail">
            <div class="option-convesor">
              <img [src]="option.imageSrc" alt="{{ option.title }}">
              <div class="option-title">
                <div class="option-description">
                  <h3>{{ option.title }}</h3>
                  <p>{{ option.description }}</p>
                </div>
                <div class="know-more">
                  <a [href]="option.link">Conocé más</a>
                  <img src="../../../assets/icon/icon-know-more.svg" alt="Conocé más">
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </swiper>
  </div>
   

  <div class="container-1280" [ngClass]="{ 'hidden': !isMobile }">
    <div class="swiper-wrapper" [ngClass]="{ 'mobile-swiper': isMobile }">
      <app-benefits-item [dashboard]="true" [benefit]="slidersBenefit"></app-benefits-item>
    </div>
  </div>
  
  <swiper #swiperHero [ngClass]="{'swiper-lottery': sorteosDisplay.length > 1}" [config]="sorteosDisplay.length > 1 ? configDraw : config" *ngIf="checkShowSlider() && sorteosDisplay && sorteosDisplay.length > 0 && !isMobile">
      <ng-template swiperSlide *ngFor="let item of sorteosDisplay " >
        <div class="swiper-slide">
          <a *ngIf="item.description9 === 'Item|código,códigos' && item.code === 'sorteo_ags_2'; else noLink" [routerLink]="['/sorteos', item.code]">
            <div class="main-banner" [ngStyle]="{
              'align-items': (item.description11 === 'A5') ? 'flex-end' : 'center',
              'justify-content': (item.code === 'sorteo_ags_2') ? 'flex-start' : (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' || item.description11 === 'A5') ? 'flex-end' : 'flex-start',
              'border-radius': (sorteosDisplay.length > 1) ? '14px' : '0px'
          }">
            <img
              *ngIf="item.description9 === 'Item|código,códigos' && item.code === 'sorteo_ags_2' && item.available === true; else defaultImage"
              src="../../../assets/images/BannerDesktopAGS.jpg"
              class="bg-img"
            />
            <img
              *ngIf="item.description9 === 'Item|código,códigos' && item.code === 'sorteo_ags_2' && item.available === false; else defaultImage"
              src="../../../assets/images/soldOutDesktop.jpg"
              class="bg-img"
            />
            <ng-template #defaultImage>
              <img src="{{ item.largeImageURL }}" class="bg-img" />
            </ng-template>

            <div class="row position-relative" [ngClass]="{'container-text': item.description11 !== 'A1 RIGHT' && item.description11 !== 'A2 RIGHT' && item.description11 !== 'A5' && sorteosDisplay.length > 1}">
              <div class="banner-text-container" [ngClass]="{
                'squareLotery': sorteosDisplay.length > 1,
                'transparent-bg': (item.description11 === 'A2 LEFT' || item.description11 === 'A2 RIGHT' || item.description11 === 'A3 NO BACKGROUND'), 'noText': (item.description11 === 'A5') }" [ngStyle]="{'width': (item.description11 === 'A3 BACKGROUND' || item.description11 === 'A3 NO BACKGROUND' ) ? '100vw' : '50vw'}">
                <div *ngIf="item.description7" class="heading winnerDraw" [ngStyle]="{'align-items': (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' ) ? 'flex-end' : 'flex-start' }">
                  <h1 [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }">SORTEO FINALIZADO</h1>
                  <h2 class="congrats" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND' ) && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#666666' : '#FBCE07','font-size': (sorteosDisplay.length > 1) ? '28px' : '52px' }">¡FELICITACIONES A LOS GANADORES!</h2>
                  <a [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }" href="/historial-sorteos">Conoce los ganadores</a>
                  <p [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#666666' : '#FBCE07' }">¡Seguí participando de nuestros sorteos para poder obtener la mejor experiencia Shell Box!</p>
                </div>
                <div *ngIf="!item.description7" class="heading" [ngClass]="{ 'transparent-bg': (item.description11 === 'A2 LEFT' || item.description11 === 'A2 RIGHT' || item.description11 === 'A3 NO BACKGROUND' || item.description11 === 'A5' ) }" [ngStyle]="{'align-items': (item.description11 === 'A3 BACKGROUND' || item.description11 === 'A3 NO BACKGROUND') ? 'center' : (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT') ? 'flex-end' : 'flex-start'}">
                  <h1 *ngIf="item.description11 !== 'A5'" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF', 'text-align': (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' ) ? 'end' : 'start' }">{{ getItemValue(item, 'longDescription', 0) }} {{ getItemValue(item, 'longDescription', 1) }}</h1>
                  <p *ngIf="item.description11 !== 'A5'" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#666666' : '#FBCE07' }">{{ getItemValue(item, 'longDescription', 2) }}</p>
                  <h4 *ngIf="item.description11 !== 'A3 BACKGROUND' && item.description11 !== 'A3 NO BACKGROUND' && item.description11 !== 'A5'" style="font-size: 26px;" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }">¡Sorteamos el {{item.description2}}!</h4>
                </div>
                <div class="participate" [ngClass]="{'centerBtn': (item.description11 === 'A3 NO BACKGROUND' || item.description11 === 'A3 BACKGROUND') }" [ngStyle]="{'justify-content': (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' ) ? 'flex-end' : 'flex-start'}">
                  <a *ngIf="!item.description7 && item.code !== 'sorteo_ags_2' && item.code !== 'sorteo_trap_sabado' && item.code !== 'sorteo_trap_domingo1'" href="" [routerLink]="['/sorteos', item.code]">
                    <button>Quiero participar</button>
                  </a>
                  <h4 *ngIf="item.description11 === 'A3 BACKGROUND' || item.description11 === 'A3 NO BACKGROUND'" [ngStyle]="{ 'color': (item.description11 === 'A3 NO BACKGROUND' ) && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }">¡Sorteamos el {{item.description2}}!</h4>
                </div>
              </div>
            </div>
          </div>
        </a>

        <ng-template #noLink>
          <div class="main-banner" [ngStyle]="{
            'align-items': (item.description11 === 'A5') ? 'flex-end' : 'center',
            'justify-content': (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' || item.description11 === 'A5' ) ? 'flex-end' : 'flex-start',
            'border-radius': (sorteosDisplay.length > 1) ? '14px' : '0px'
          }">
          <a *ngIf="item.description9 === 'Item|entrada,entradas'" [routerLink]="['/sorteos', item.code]" >
            <img [src]="getBannerImageSrc(item.code)" alt="Banner" />
          </a>
          <img *ngIf="!((item.description9 === 'Item|entrada,entradas' && item.code === 'sorteo_trap_domingo1') || (item.description9 === 'Item|entrada,entradas' && item.code === 'sorteo_trap_sabado'))" [src]="item.largeImageURL" alt="Banner Image" class="bg-img"/>

            <div class="row text-swipper" [ngStyle]="{'width': (item.description11 === 'A3 BACKGROUND' || item.description11 === 'A3 NO BACKGROUND' && sorteosDisplay.length > 1 ) ? '100%' : ''}" [ngClass]="{'container-text': item.description11 !== 'A1 RIGHT' && item.description11 !== 'A2 RIGHT' && item.description7 !== null && sorteosDisplay.length > 1}">
              <div class="banner-text-container" [ngClass]="{
                'squareLotery': sorteosDisplay.length > 1,
                'transparent-bg': (item.description11 === 'A2 LEFT' || item.description11 === 'A2 RIGHT' || item.description11 === 'A3 NO BACKGROUND'), 'noText': (item.description11 === 'A5') }" [ngStyle]="{'width': (item.description11 === 'A3 BACKGROUND' || item.description11 === 'A3 NO BACKGROUND' ) ? '100vw' : '50vw'}">
                <div *ngIf="item.description7" class="heading winnerDraw" [ngStyle]="{'align-items': (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' ) ? 'flex-end' : 'flex-start' }">
                  <h1 [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }">SORTEO FINALIZADO</h1>
                  <h2 class="congrats" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND' ) && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#666666' : '#FBCE07','font-size': (sorteosDisplay.length > 1) ? '28px' : '52px' }">¡FELICITACIONES A LOS GANADORES!</h2>
                  <a [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }" href="/historial-sorteos">Conoce los ganadores</a>
                  <p [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#666666' : '#FBCE07' }">¡Seguí participando de nuestros sorteos para poder obtener la mejor experiencia Shell Box!</p>
                </div>
                <div *ngIf="!item.description7" class="heading" [ngClass]="{ 'transparent-bg': (item.description11 === 'A2 LEFT' || item.description11 === 'A2 RIGHT' || item.description11 === 'A3 NO BACKGROUND' || item.description11 === 'A5' ) }" [ngStyle]="{'align-items': (item.description11 === 'A3 BACKGROUND' || item.description11 === 'A3 NO BACKGROUND') ? 'center' : (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT') ? 'flex-end' : 'flex-start'}">
                  <h1 *ngIf="item.description11 !== 'A5'" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF', 'text-align': (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' ) ? 'end' : 'start' }">{{ getItemValue(item, 'longDescription', 0) }} {{ getItemValue(item, 'longDescription', 1) }}</h1>
                  <p *ngIf="item.description11 !== 'A5'" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#666666' : '#FBCE07' }">{{ getItemValue(item, 'longDescription', 2) }}</p>
                  <h4 *ngIf="item.description11 !== 'A3 BACKGROUND' && item.description11 !== 'A3 NO BACKGROUND' && item.description11 !== 'A5'" style="font-size: 26px;" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }">¡Sorteamos el {{item.description2}}!</h4>
                </div>
                <div class="participate" [ngClass]="{'centerBtn': (item.description11 === 'A3 NO BACKGROUND' || item.description11 === 'A3 BACKGROUND') }" [ngStyle]="{'justify-content': (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' ) ? 'flex-end' : 'flex-start'}">
                  <a *ngIf="!item.description7 && item.code !== 'sorteo_ags_2' && item.code !== 'sorteo_trap_sabado' && item.code !== 'sorteo_trap_domingo1'" href="" [routerLink]="['/sorteos', item.code]">
                    <button>Quiero participar</button>
                  </a>
                  <h4 *ngIf="item.description11 === 'A3 BACKGROUND' || item.description11 === 'A3 NO BACKGROUND'" [ngStyle]="{ 'color': (item.description11 === 'A3 NO BACKGROUND' ) && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }">¡Sorteamos el {{item.description2}}!</h4>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        </div>
          <div class="swiper-pagination"></div>
      </ng-template>
  </swiper>

  <swiper #swiperHero [config]="sorteosDisplay.length > 1 ? configDraw : config" *ngIf="checkShowSlider() && sorteosDisplay && sorteosDisplay.length > 0 && isMobile" class="swiper-lottery">
    <ng-template swiperSlide *ngFor="let item of sorteosDisplay">
      <div class="swiper-slide">
        <ng-container *ngIf="item.description9 === 'Item|código,códigos' && item.code === 'sorteo_ags_2'; else otherLinks">
          <a [routerLink]="['/sorteos', item.code]">
            <img
              [src]="item.available ? '../../../assets/images/BannerMobileAGS.jpg' : '../../../assets/images/soldOutMobile.jpg'"
              alt="Slide Image"
              class="main-banner-image"
            />
          </a>
        </ng-container>
        <ng-template #otherLinks>
          <ng-container *ngIf="item.description9 === 'Item|entrada,entradas' && item.code !== 'sorteo_tiago_pzk'; else noLink">
            <a [routerLink]="['/sorteos', item.code]">
              <img [src]="item.mediumImageURL" [ngStyle]="{ 'border-radius': (sorteosDisplay.length > 1) ? '14px' : '0px' }" class="banner-mobile" alt="Banner" style="width: 100%;" />
            </a>
          </ng-container>
        </ng-template>   
        <ng-template #noLink>
          <img
            [src]="item.mediumImageURL"
            alt="Slide Image"
            class="main-banner-image"
            [ngStyle]="{ 'border-radius': (sorteosDisplay.length > 1) ? '14px' : '0px' }"
            style="width: 100%;"
          />
        </ng-template>        
        <div class="main-banner" style="position: absolute; bottom: 0; justify-content: center;">
          <div class="row" [ngClass]="{'w-100': sorteosDisplay.length > 1}">
            <div class="col-md-6 banner-text-container" [ngClass]="{
              'transparent-bg': (item.description11 === 'A2 LEFT' || item.description11 === 'A2 RIGHT' || item.description11 === 'A5' || item.description11 === 'A3 NO BACKGROUND' ),
              'sorteosDisplay': sorteosDisplay.length > 1
            }">
              <div *ngIf="item.description7" class="heading winnerDraw" [ngStyle]="{'text-align': (item.description11 === 'A1 RIGHT' && item.description11 === 'A2 RIGHT' ) ? 'end' : 'start' }">
                <h1 [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' && item.description11 === 'A2 LEFT') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }">SORTEO FINALIZADO</h1>
                <h2 class="congrats" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' && item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND' ) && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#666666' : '#FBCE07', 'font-size': (sorteosDisplay.length > 1) ? '23px' : '28px'  }">¡FELICITACIONES A LOS GANADORES!</h2>
                <a [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }" href="/historial-sorteos">Conoce los ganadores</a>
                <p [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#666666' : '#FFFFFF', 'text-align': (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' ) ? 'end' : 'start' }">¡Seguí participando de nuestros sorteos para poder obtener la mejor experiencia Shell Box!</p>
              </div>
              <div ngClass]="{'w-100': sorteosDisplay.length > 1, 'd-flex justify-content-center': item.code === 'entrada_tc_buenos_aires'}" *ngIf="!item.description7" [ngStyle]="{'text-align': (item.description11 === 'A1 RIGHT' || item.description11 === 'A2 RIGHT' ) ? 'end' : 'start' }">
                <h2 class="description" *ngIf="item.description11 !== 'A5'" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF', 'font-size': item.description11 === 'A5' ? '20px' : '32px', 'text-align': (item.description11 === 'A3 BACKGROUND' || item.description11 === 'A3 NO BACKGROUND') ? 'center' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A1 RIGHT') ? 'end' : 'start'}">{{ getItemValue(item, 'longDescription', 0) }} {{ getItemValue(item, 'longDescription', 1) }}</h2>
                <p *ngIf="item.description11 !== 'A5'" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT' || item.description11 === 'A3 NO BACKGROUND') && item.description10 === 'Blanco' ? '#666666' : '#FBCE07', 'text-align': item.description11 === 'A3 BACKGROUND' || item.description11 === 'A3 NO BACKGROUND' ? 'center' : '' }">{{ getItemValue(item, 'longDescription', 2) }}</p>
                <h4  *ngIf="item.description11 !== 'A3 BACKGROUND' && item.description11 !== 'A3 NO BACKGROUND' && item.description11 !== 'A5'" [ngStyle]="{ 'color': (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Amarillo' ? '#666666' : (item.description11 === 'A2 RIGHT' || item.description11 === 'A2 LEFT') && item.description10 === 'Blanco' ? '#DD1D21' : '#FFFFFF' }" style="font-size: 19px;">¡Sorteamos el {{item.description2}}!</h4>
                <a *ngIf="!item.description7 && item.code !== 'sorteo_ags_2' && item.code !== 'sorteo_trap_sabado' && item.code !== 'sorteo_trap_domingo1' && !item.code.includes('quevedo')" href="" [routerLink]="['/sorteos', item.code]" class="mt-3"><button>Quiero participar</button></a>
              </div>
            </div>
          </div>
        </div>
        <button *ngIf="item.code.includes('quevedo')" class="quevedo-participate-btn" [routerLink]="['/sorteos', item.code]">Quiero participar</button>
        <div class="swiper-pagination"></div>
      </div>
    </ng-template>
  </swiper>

  <div class="step-container">
    <div class="steps-detail">
      <div class="steps">
        <h2>Descargá la app y sumate a Shell Box</h2>
        <div *ngFor="let step of steps">
          <div class="steps-description">
            <span>{{ step.numero }}.</span>
            <div class="step-title">
              <h4>{{ step.titulo }}</h4>
              <p>{{ step.descripcion }}</p>
            </div>
          </div>
        </div>      
        <div class="download-store">
          <span>Empezá ahora</span>
          <div class="store-option">
            <a
            href="https://play.google.com/store/apps/details?id=com.raizen.acelera&pli=1"
            target="_blank"
          >
          <img src="../../../assets/icon/icon-google-store-black.svg" alt="Google Play">
          </a>
          <a
            href="https://apps.apple.com/ar/app/shell-box-pague-e-ganhe/id1037433060"
            target="_blank"
          >
          <img src="../../../assets/icon/icon-app-store-black.svg" alt="App Store">
          </a>
          </div>
        </div>
      </div>
      <img [src]="imageSrc" alt="Descarga la app">
    </div>
  </div>
</div>
